module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("编辑设备")])])], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "equipmentForm",
    attrs: {
      "model": _vm.equipmentForm,
      "rules": _vm.addEquipmentRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "设备序列号",
      "label-width": "150px",
      "prop": "deviceId"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.equipmentForm.deviceId),
      callback: function($$v) {
        _vm.$set(_vm.equipmentForm, "deviceId", $$v)
      },
      expression: "equipmentForm.deviceId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "条形码编码",
      "label-width": "150px",
      "prop": "productIdentity"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.equipmentForm.productIdentity),
      callback: function($$v) {
        _vm.$set(_vm.equipmentForm, "productIdentity", $$v)
      },
      expression: "equipmentForm.productIdentity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所在仓库",
      "label-width": "150px",
      "prop": "storageId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "仓库"
    },
    model: {
      value: (_vm.equipmentForm.storageId),
      callback: function($$v) {
        _vm.$set(_vm.equipmentForm, "storageId", $$v)
      },
      expression: "equipmentForm.storageId"
    }
  }, _vm._l((_vm.storageArr), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.storageName,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "添加字段",
      "label-width": "150px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addProperty($event)
      }
    }
  }, [_vm._v("增加")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_vm._v("key:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.key),
      callback: function($$v) {
        _vm.key = $$v
      },
      expression: "key"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_vm._v("value:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)], 1), _vm._v(" "), (_vm.property.length) ? _c('el-form-item', {
    attrs: {
      "label": "已加字段",
      "label-width": "150px"
    }
  }, _vm._l((_vm.property), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "mt10"
    }, [_vm._v("\n                " + _vm._s(++index) + "、" + _vm._s(item.name) + " - " + _vm._s(item.value) + "\n                "), _c('el-button', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeProperty(index)
        }
      }
    }, [_vm._v("删除")])], 1)
  }), 0) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注信息",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.equipmentForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.equipmentForm, "remark", $$v)
      },
      expression: "equipmentForm.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18e28564"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/product/EditEquipment.vue
// module id = 715
// module chunks = 1